import { useState } from 'react';
import { Button } from '@busbook/ui';
import { usePush } from '../lib/push.js';
import { useT } from '../i18n/index.js';

/**
 * Shown on a confirmed ticket, never on a first visit (docs/05). The copy says
 * what the passenger gets, not what the app wants.
 */
export function PushPrompt({ appName }: { appName: string }) {
  const t = useT();
  const { shouldOffer, subscribe, busy } = usePush();
  const [dismissed, setDismissed] = useState(false);
  const [enabled, setEnabled] = useState(false);

  if (enabled) {
    return (
      <p className="text-center text-xs" style={{ color: 'var(--signal-departed)' }}>
        {t('pp.willRemind')}
      </p>
    );
  }

  if (!shouldOffer || dismissed) return null;

  return (
    <div
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--color-line)', background: 'var(--color-surface)' }}
    >
      <p className="text-sm font-semibold">{t('pp.getReminders')}</p>
      <p className="mt-1 text-sm" style={{ color: 'var(--color-muted)' }}>
        {appName} can alert you before your bus leaves, and if the schedule changes.
      </p>
      <div className="mt-3 flex gap-2">
        <Button
          size="sm"
          loading={busy}
          onClick={async () => {
            const ok = await subscribe();
            if (ok) setEnabled(true);
            else setDismissed(true);
          }}
        >
          {t('pp.turnOn')}
        </Button>
        <Button size="sm" variant="ghost" onClick={() => setDismissed(true)}>
          {t('pp.notNow')}
        </Button>
      </div>
    </div>
  );
}
